import * as THREE from 'three';
export function toggleTransparency(host) {
    host.allowTransparency = !host.allowTransparency;
    console.log(`Transparency ${host.allowTransparency ? 'enabled' : 'disabled'}`);
    // Update UI button state
    const button = document.getElementById('toggle-transparency');
    if (button) {
        button.classList.toggle('active', host.allowTransparency);
    }
    // Update all existing materials with new transparency settings
    updateAllMaterialsForTransparency(host);
    // Show status message
    host.showStatus(`Transparency ${host.allowTransparency ? 'enabled' : 'disabled'}: ${host.allowTransparency ? 'Alpha blending available (may impact performance)' : 'Optimized opaque rendering'}`);
    host.requestRender();
}
export function updateAllMaterialsForTransparency(host) {
    // Update all mesh materials with transparency settings
    host.meshes.forEach(mesh => {
        if (mesh instanceof THREE.Points && mesh.material instanceof THREE.PointsMaterial) {
            const material = mesh.material;
            // The adaptive renderer mirrors blending to its round pass before render.
            material.transparent = host.allowTransparency;
            material.needsUpdate = true;
        }
    });
    // Update vertex points objects
    host.vertexPointsObjects.forEach(vertexPoints => {
        if (vertexPoints && vertexPoints.material instanceof THREE.PointsMaterial) {
            const material = vertexPoints.material;
            // Only toggle blending; preserve the material's existing point shape.
            material.transparent = host.allowTransparency;
            material.needsUpdate = true;
        }
    });
    // Update multi-material groups
    host.multiMaterialGroups.forEach(group => {
        if (group) {
            group.traverse(child => {
                if (child instanceof THREE.Points && child.material instanceof THREE.PointsMaterial) {
                    const material = child.material;
                    // Keep the material's existing point shape; only toggle blending.
                    material.transparent = host.allowTransparency;
                    material.needsUpdate = true;
                }
            });
        }
    });
    console.log(`Updated transparency for ${host.meshes.length} main meshes, ${host.vertexPointsObjects.length} vertex point objects, and ${host.multiMaterialGroups.length} multi-material groups`);
}
